import { createSvgIcon } from '@mui/material';

const DownloadResume = createSvgIcon(
  <svg
    width="21.855"
    height="18.559999"
    viewBox="0 0 21.855 18.56"
    version="1.1"
    id="svg1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g
      id="Group_Resume"
      data-name="Group Resume"
      transform="matrix(0.83843053,0,0,0.83843053,-1.1582377,-3.5164137)"
    >
      <path
        id="Path_Cloud"
        data-name="Path Cloud"
        d="m 19,18 a 3.5,3.5 0 1 0 0,-7 H 18 A 5.093,5.093 0 0 0 13.611,5.05 5.621,5.621 0 0 0 7,9 4.574,4.574 0 0 0 2.334,12.373 4.349,4.349 0 0 0 4.9,17.4"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.3"
      />
      <line
        id="Line_Arrow"
        data-name="Line Arrow"
        y2="9"
        transform="translate(12,13)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        x1="0"
        y1="0"
        x2="0"
      />
      <path
        id="Path_Arrow"
        data-name="Path Arrow"
        d="m 9,19 3,3 3,-3"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <g transform="translate(-0.5, 1.5)">
      <rect x="6" y="15.5" width="10" height="2.5" rx="0.3" fill="#12344A" opacity="0.9" />
      <path
        d="M 7,16.2 h 2 m -2,0.6 h 3 m -3,0.6 h 2.5"
        stroke="#ffffff"
        strokeWidth="0.35"
        strokeLinecap="round"
      />
      <circle cx="13.5" cy="16.75" r="0.8" fill="#85C440" />
      <path
        d="M 13.2,16.5 l 0.3,0.3 0.5,-0.5"
        stroke="#ffffff"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  </svg>,
  'DownloadResume',
);

export default DownloadResume;
